/**
 * Build and buy util logic.
 */
import { createLogic } from "redux-logic";
import {
    type SetFinanceOptionType,
    SET_FINANCE_OPTION,
} from "../../../../../common-deprecated/redux/actions/UtilActions";
import { addFinancePack, addPack, removeFinancePack, removePack } from "../actions/BasketActions";
import { startConfigSave } from "../actions/SaveActions";
import type { BuildAndBuyLogicType } from "../store";
import CarDataConsolidator from "../../../../shared-logic/utils/classes/CarDataConsolidator";
import { NavStep } from "../../../shared-logic/utils/Navigation";

const setFinanceOptionLogic = (createLogic as BuildAndBuyLogicType<SetFinanceOptionType>)({
    type: SET_FINANCE_OPTION,

    validate({ getState, action }, allow, reject) {
        const { utils } = getState();
        if (utils.financeOption === action.option) {
            (reject as () => void)();
        } else {
            allow(action);
        }
    },

    process({ getState, action }, dispatch, done) {
        const { navigation, items, basket } = getState();
        const standardOnMonthlyEnabledPacks = items.packs.filter(
            (pack) =>
                pack.standardOnMonthlyRateToggle &&
                // See also packUtils for similar logic.
                !pack.standard &&
                CarDataConsolidator.isAvailable(pack, basket.colour, basket.upholstery).available,
        );

        // Some packs should be selected when toggling to monthly rate and become standard.
        // If that happens the price still is taken into account though, logic to check if the pack is already selected is handled in BasketLogic
        if (action.option === "monthly") {
            standardOnMonthlyEnabledPacks.forEach((pack) => dispatch(addPack(pack, [], [], false, false, false, true)));
            items.financePacks.forEach((pack) => dispatch(addFinancePack(pack, true)));
        } else {
            // When toggling back to cash check if the pack was user selected, if not, remove it again
            standardOnMonthlyEnabledPacks
                .filter((pack) => !pack.userSelected)
                .forEach((pack) => dispatch(removePack(pack, true)));
            items.financePacks.forEach((pack) => dispatch(removeFinancePack(pack, true)));
        }

        if (navigation.step === NavStep.Summary) {
            dispatch(startConfigSave());
        }

        done();
    },
});

export default [setFinanceOptionLogic];
